import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
import { PropertyService } from './property.service';
import { Params } from '@angular/router';
import { ApartmentType, PropertySearch, AdvancedLimits } from './../models/index';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class ApartmentTypeService extends BaseApiService implements Resolve<ApartmentType> {
  constructor(
    private propertyService: PropertyService,
    private apiCallService: ApiCallService,
    private router: Router
  ) {
    super();
  }

  getApartmentTypes(propertySearch?: PropertySearch, sort?: string, page?: number): Promise<ApartmentType[]> {
    let path = '/apartment_types';

    if (propertySearch) {
      path += this.apiCallService.getSeachUrlParams(propertySearch, sort, page);
    }
    return this.apiCallService.get(path);
  }

  getApartmentType(friendly_id: string): Promise<ApartmentType> {
    return this.apiCallService.get('/apartment_types/' + friendly_id);
  }

  decodeUrlParams(params: Params, advancedLimits?: AdvancedLimits, oldPropertySearch?: PropertySearch): PropertySearch {
    return this.propertyService.decodeUrlParams(params, advancedLimits, oldPropertySearch);
  }

  resolve(route: ActivatedRouteSnapshot): Promise<ApartmentType> {
    let promise;

    const page = route.data['page'] ? route.data['page'] : 1;

    if (route.params['friendly_id'] === undefined) {

      if (route.data['property_search']) {

        promise = this.getApartmentTypes(route.data['property_search'], undefined, page);

      } else if (route.data['property_type']) {

        const propertySearch = this.propertyService.decodeUrlParams(route.queryParams);
        propertySearch.property_type = route.data['property_type'];
        promise = this.getApartmentTypes(propertySearch, undefined, page);

      } else {
        promise = this.getApartmentTypes(new PropertySearch(), undefined, 1);
      }
    } else {
      promise = this.getApartmentType(route.params['friendly_id'])
        .catch(error => {
          this.router.navigate(['/apartamente']);
          throw error;
        });
    }

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/apartment-type.service.ts